export default {
  ACCESS_LEVEL: 'accessLevel',
  ACTION_TYPE_ACCESS: 'actionTypeAccess',
  BASELINE_ACTION_ACCESS_LEVEL: 'baselineActionAccessLevel',
  OBJECT_TYPE_ID: 'objectTypeId'
};